var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M1.75 7c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25V7Zm15 3.543V7A2.75 2.75 0 0 0 14 4.25H3A2.75 2.75 0 0 0 .25 7v10A2.75 2.75 0 0 0 3 19.75h11A2.75 2.75 0 0 0 16.75 17v-3.543l5.814 4.153A.75.75 0 0 0 23.75 17V7a.75.75 0 0 0-1.186-.61l-5.814 4.153Zm5.5 5L17.29 12l4.96-3.543v7.086Z",
    clipRule: "evenodd"
  })));
};
export default SvgVideo;